import React, { useEffect, useRef, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { auth } from './services/api';
import Login from './components/Login';
import EnTete from './components/EnTete';
import { Chargement } from './components/communs';
import TableauDeBord from './pages/TableauDeBord';
import Projets from './pages/Projets';
import Projet from './pages/Projet';
import MesTaches from './pages/MesTaches';
import Parametres from './pages/Parametres';
import Documentation from './pages/Documentation';

// Coquille A97 Projets : connexion Microsoft (même circuit que BI, DATA, NDF),
// session par jeton, puis l'application (bandeau et pages calqués sur A97 Hub).
function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authError, setAuthError] = useState('');
  const oidcHandled = useRef(false); // double-échange du code en StrictMode

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    // DÉVELOPPEMENT UNIQUEMENT : ?jeton=<jwt> pose le jeton (pas de Microsoft en local).
    if (process.env.NODE_ENV === 'development' && params.get('jeton')) {
      localStorage.setItem('projets-token', params.get('jeton'));
      window.location.replace('/');
      return;
    }
    const retourOidc = window.location.pathname === '/oidc/callback' || params.has('code');
    if (retourOidc && !oidcHandled.current) {
      oidcHandled.current = true;
      traiterRetourOidc(params);
    } else {
      verifierSession();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const verifierSession = async () => {
    if (localStorage.getItem('projets-token')) {
      try { setUser((await auth.getMe()).data.user); } catch (e) { localStorage.removeItem('projets-token'); }
    }
    setLoading(false);
  };

  const traiterRetourOidc = async (params) => {
    const nettoyerUrl = () => window.history.replaceState({}, '', '/');
    try {
      const erreurOauth = params.get('error_description') || params.get('error');
      if (erreurOauth) throw new Error(erreurOauth);
      const res = await auth.microsoftCallback(params.get('code'), params.get('state'));
      nettoyerUrl();
      localStorage.setItem('projets-token', res.data.token);
      setUser(res.data.user);
    } catch (error) {
      nettoyerUrl();
      setAuthError(error.response?.data?.error || error.message || 'Échec de la connexion Microsoft');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Chargement texte="Connexion…" />;
  if (!user) return <Login authError={authError} />;

  const deconnexion = () => { localStorage.removeItem('projets-token'); setUser(null); };
  return (
    <>
      <EnTete user={user} setUser={setUser} onDeconnexion={deconnexion} />
      <main>
        <Routes>
          <Route path="/" element={<TableauDeBord moi={user} />} />
          <Route path="/projets" element={<Projets moi={user} />} />
          <Route path="/projets/:id" element={<Projet moi={user} />} />
          <Route path="/mes-taches" element={<MesTaches moi={user} />} />
          <Route path="/documentation" element={<Documentation moi={user} />} />
          <Route path="/parametres" element={user.role === 'admin' ? <Parametres moi={user} /> : <Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
}

export default App;
